import { render, staticRenderFns } from "./SweepFolderDefaultsModal.vue?vue&type=template&id=273dc4b2&"
import script from "./SweepFolderDefaultsModal.vue?vue&type=script&lang=ts&"
export * from "./SweepFolderDefaultsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports